export default function () {
  return [

    {
      title: 'Generic (Amazon,Noon,etc)',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',
      items:[

        {
          title: 'Generic Upload',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Generic-Upload',
          },
        },

        {
          title: 'Generic Upload New',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Generic-Upload-New',
          },
        },
        
        
        {
          title: ' SKU Generator',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'SKU-Generator',
          },
        },
       


        {
          title: 'Upload Sycc',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Upload-Sycc',
          },
        },
       

        
      ]
    },

    {
      title: 'QC',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',

      items:[
        {
          title: 'Multiplier',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Multiplier',
          },
        },
        {
          title: 'Pricing QC',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Pricing-QC',
          },
        },
      ]
    },

    {
      title: 'Vtex',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',

      items:[
        {
          title: 'Product Upload',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Product-Upload',
          },
        },
        {
          title: 'Vtex Product Upload JOB',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Upload-JOB',
          },
        },
        {
          title: 'Vtex Pricing Upload JOB',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Vtexpriceupload-Job',
          },
        },
        // VtexpricingJob
        
        {
          title: 'Bulletpoints Update',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Bulletpoints-Update',
          },
        },
        {
          title: 'Brand Upload',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Brand-Upload',
          },
        },
    
        {
          title: 'Brand & Catagory Update',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Brand-Catagory-Update',
          },
        },
        {
          title: 'Brand & Catagory View',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Brand-And-Catagory-View',
          },
        },
    
      ]
    },
    {
      title: 'Inventory',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',
      items:[
        {
          title: 'Inventory Upload',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Inventory-Upload',
          },
        },
        {
          title: 'Handling Days Upload',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Handlingdays-Upload',
          },
        },
        {
          title: 'Reference Price Upload',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Referenceprice-Upload',
          },
        },
      ]
    },
    {
      title: 'Utlity',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',
      items:[
    {
        title: 'Image Search',
        // htmlBefore: '<i class="material-icons">view_module</i>',
        to: {
          name: 'Image-Search',
        },
      },
    {
      title: 'Singleimage Search',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      to: {
        name: 'Singleimage-Search',
      },
    },
      ]
    },

    

    {
      title: 'Job',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',
      items:[
        {
          title: 'Vtex Job',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Vtex-Job',
          },
        },
        {
          title: 'Vtex Pricing Job',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Vtexpricing-Job',
          },
        },
        // VtexpricingJob
    
      ]
    },


    {
      title: 'Master',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',
      items:[
        {
          title: 'Category Master',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Category-Dashboard',
          },
        },
        {
          title: 'Category',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'Category-Add',
          },
        },
      ]
    },

    {
      title: 'Setup',
      // htmlBefore: '<i class="material-icons">view_module</i>',
      // to: {
      //   // name: 'Generic-Upload',
      // },
      htmlAfter: '',
      items:[
        {
          title: 'User Setup',
          // htmlBefore: '<i class="material-icons">view_module</i>',
          to: {
            name: 'user-setup',
          },
        },
      ]
    },

 

    {
      title: 'Support',
      // htmlBefore: '<i class="material-icons">error</i>',
      to: {
        name: 'errors',
      },
    }
  ];
}
